var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.5 2-.16.03L15 4.1 9 2 3.36 3.9c-.21.07-.36.25-.36.48V19.5a.5.5 0 0 0 .5.5l.16-.03L9 17.9l1.645.576a7.53 7.53 0 0 1-.114-2.16L10 16.13V4.47l4 1.4v4.785a7.46 7.46 0 0 1 2-.885V5.86l3-1.16v4.866a7.447 7.447 0 0 1 2 .558V2.5a.5.5 0 0 0-.5-.5zM8 4.45 5 5.46v11.85l3-1.16V4.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.819 17.486c.022-.157.037-.322.037-.486a3.7 3.7 0 0 0-.037-.493l1.087-.828a.248.248 0 0 0 .058-.322l-1.028-1.728c-.066-.108-.198-.15-.316-.108l-1.277.5a3.79 3.79 0 0 0-.867-.492l-.19-1.322a.265.265 0 0 0-.258-.207h-2.056a.265.265 0 0 0-.257.214l-.191 1.322a3.966 3.966 0 0 0-.867.493l-1.277-.5a.263.263 0 0 0-.316.107l-1.028 1.728a.248.248 0 0 0 .058.322l1.087.828a3.506 3.506 0 0 0-.036.486c0 .164.014.329.036.493l-1.087.828a.248.248 0 0 0-.058.322l1.028 1.728c.066.108.198.15.316.108l1.277-.5c.265.2.551.364.867.492l.19 1.322a.265.265 0 0 0 .258.207h2.056a.265.265 0 0 0 .257-.214l.191-1.322c.309-.128.602-.293.867-.493l1.277.5c.118.043.25 0 .316-.107l1.028-1.728a.248.248 0 0 0-.058-.322l-1.087-.828zM16.5 17c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSetting);
export default __webpack_public_path__ + "static/media/map_setting.d76c9272bb93d4b08b029499fc62e9db.svg";
export { ForwardRef as ReactComponent };